import { UpdatePlanDiscountDto } from "@/hooks/esim-plans/types/useEsimPlansListType";
import { api } from "@/api/Api";

export const updatePlanDiscount = (data: UpdatePlanDiscountDto) => {
  return api.updateEsimPlanDiscount(data);
};
